import React, { PropTypes, PureComponent } from 'react';
import { graphql } from 'react-apollo';

import authService from '../../state/services/auth';
import { UserQueryPrivate, UserQueryPublicBasic } from '../../state/services/gql/user';

import HeaderMenu from '../../components/HeaderMenu';

/**
  * Header menu container component.
  * Wraps the header menu in state to control visibility.
 */
class HeaderMenuContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      navVisible: false,
      searchVisible: false,
    };
  }

  handleButtonClick = (event) => {
    const { target } = event || {};
    if (target) {
      target.blur();
    }
    this.toggleNavVisibility();
  }

  toggleNavVisibility = () => {
    this.setState(({ navVisible }) => ({
      navVisible: !navVisible,
    }));
  }

  handleSearchClick = () => {
    this.toggleSearchVisibility();
  }

  toggleSearchVisibility = () => {
    this.setState(({ searchVisible }) => ({
      searchVisible: !searchVisible,
    }));
  }

  render() {
    const loggedIn = authService.loggedIn();
    const { profile } = this.props.data;
    const { navVisible, searchVisible } = this.state;
    return (
      <HeaderMenu
        loggedIn={loggedIn}
        navVisible={navVisible}
        profile={profile}
        onButtonClick={this.handleButtonClick}
        onMaskClick={this.handleButtonClick}
        onNavCloseClick={this.handleButtonClick}
        onNavLinkClick={this.handleButtonClick}
        onSearchCloseClick={this.handleSearchClick}
        onSearchLinkClick={this.handleSearchClick}
        searchVisible={searchVisible}
        {...this.props}
      />
    );
  }
}

HeaderMenuContainer.propTypes = {
  data: PropTypes.shape(),
};

HeaderMenuContainer.defaultProps = {
  data: {},
};


export default (props) => {
  const HeaderMenuContainerWithGraphQL = graphql(
    authService.loggedIn ? UserQueryPrivate : UserQueryPublicBasic,
    {
      options: { variables: { id: authService.getUserCookie() } },
      skip: !authService.getUserCookie(),
    },
  )(
    HeaderMenuContainer,
  );

  return <HeaderMenuContainerWithGraphQL {...props} />;
};



// WEBPACK FOOTER //
// ./app/src/containers/HeaderMenu/index.jsx